module.exports = __webpack_public_path__ + "static/media/saasjiesuanxitong.8c9f6859.jpg";